import { StyledCard } from "../AccountBasicInfo/AccountBacisInfo.styles";
import CustomDataGrid from '../DataGrid/DataGrid';
import { GridColDef, GridColumnHeaderParams, GridValueGetterParams } from '@mui/x-data-grid';
import { FC, useMemo, useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Box, CardContent, Typography } from "@mui/material";
import { fetchAPDashboardListCustomersDelay } from "../../store/APDashboardStore/APDashboardThunk";
import { fetchARDashboardListCustomersDelay } from "../../store/ARDashboardStore/ARDashboardThunk";
import { ApiStatus } from "../../utils/api.types";
import moment from 'moment';
import { Utils } from "../../utils/common-utils";

interface DelayTableProps {
    filter: string;
    type: string;
}

const DelayTable: FC<DelayTableProps> = ({ filter, type }) => {
    const dispatch = useAppDispatch();
    const { customerAPListDelay } = useAppSelector(state => state.APDashboard);
    const { customerARListDelay } = useAppSelector(state => state.ARDashboard);
    const { selectedAccount } = useAppSelector(state => state.auth);
    const [data, setData] = useState<any>([]);
    const columns: GridColDef[] = useMemo(() => [
        {
            field: "invoiceNumber",
            headerName: 'Invoice',
            type: "string",
            flex: 1,
        },
        {
            field: "date",
            headerName: 'Invoice Date',
            type: "string",
            flex: 1,
            renderCell: ({ row, value }: GridValueGetterParams) => (
                <>
                    {moment(value).format("DD/MM/YYYY")}
                </>
            )
        },
        {
            field: "customer",
            headerName: 'Supplier',
            type: "string",
            flex: 1,
            renderCell: ({ row, value }: GridValueGetterParams) => (
                <>
                    {row?.customer?.name}
                </>
            )
        },
        {
            field: "totalAmount",
            headerName: 'Amount',
            renderHeader: (params: GridColumnHeaderParams) => (
                <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Amount</span>
            ),
            type: "string",
            renderCell: ({ row, value }: GridValueGetterParams) => {
                return (<>
                    <Typography className="flex-end">
                        {Utils.formatNumber(row.totalAmount || 0, true, true)}
                    </Typography>
                </>);
            },
            flex: 1
        },
        {
            field: "tax",
            headerName: 'Tax',
            renderHeader: (params: GridColumnHeaderParams) => (
                <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Tax</span>
            ),
            type: "string",
            renderCell: ({ row, value }: GridValueGetterParams) => {
                return (<>
                    <Typography className="flex-end">
                        {Utils.formatNumber(row.tax || 0, true, true)}
                    </Typography>
                </>);
            },
            flex: 1
        },
        {
            field: "total",
            headerName: 'Total',
            renderHeader: (params: GridColumnHeaderParams) => (
                <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Total</span>
            ),
            type: "string",
            flex: 1,
            renderCell: ({ row, value }: GridValueGetterParams) => {
                return (<Typography className="flex-end">
                    {Utils.formatNumber(parseInt(row.totalAmount) + parseInt(row.tax) || '0', true, true)}
                </Typography>);
            }
        },
        {
            field: "totalPaid",
            headerName: 'Received',
            type: "string",
            flex: 1,
            renderHeader: (params: GridColumnHeaderParams) => (
                <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Received</span>
            ),
            renderCell: ({ row, value }: GridValueGetterParams) => {
                return (<>
                    <Typography className="flex-end">
                        {Utils.formatNumber(row.totalPaid || 0, true, true)}
                    </Typography>
                </>);
            },
        },
        {
            field: "totalOutstanding",
            headerName: 'Outstanding',
            type: "string",
            flex: 1,
            renderHeader: (params: GridColumnHeaderParams) => (
                <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Outstanding</span>
            ),
            renderCell: ({ row, value }: GridValueGetterParams) => {
                return (<>
                    <Typography className="flex-end">
                        {Utils.formatNumber(row.totalOutstanding || 0, true, true)}
                    </Typography>
                </>);
            },
        },
        {
            field: "status",
            headerName: 'Status',
            type: "string",
            flex: 1
        },
        // {
        //   field: "actions",
        //   headerName: 'Actions',
        //   type: "actions",
        //   flex: 1,
        // }
    ], []);

    useEffect(() => {
        if (filter) {
            const getDashboardCustomerListDelay = async () => {
                try {
                    if (type === 'AP') {
                        const data = await dispatch(fetchAPDashboardListCustomersDelay({ accountId: selectedAccount._id, params: filter }));
                    } else {
                        const data = await dispatch(fetchARDashboardListCustomersDelay({ accountId: selectedAccount._id, params: filter }));
                    }
                } catch (e) {
                    //console.log('getDashboardCustomerListDelay Error: ', e);
                }
            }

            getDashboardCustomerListDelay();
        }
    }, [dispatch, selectedAccount, filter]);

    useEffect(() => {
        if (type === 'AP' && customerAPListDelay.status === ApiStatus.SUCCESS) {
            setData(customerAPListDelay.dashboardCustomerListDelay.list)
        } else if (type === 'AR' && customerARListDelay.status === ApiStatus.SUCCESS) {
            setData(customerARListDelay.dashboardCustomerListDelay.list)
        }
    }, [customerAPListDelay, customerARListDelay, type]);

    // const rows = [
    //   { Invoice: 'INV-12345', InvoiceDate: '12/03/2022', Supplier: 'Aqua Born Ltd', Amount: '35', Tax:'20', Total:'400', Received:'300', Outstanding:'100', Status:'Payment Pending', actions:'pay view' },
    //   { Invoice: 'INV-12345', InvoiceDate: '12/03/2022', Supplier: 'Aqua Born Ltd', Amount: '35', Tax:'20', Total:'400', Received:'300', Outstanding:'100', Status:'Payment Pending', actions:'pay view' },
    //   { Invoice: 'INV-12345', InvoiceDate: '12/03/2022', Supplier: 'Aqua Born Ltd', Amount: '35', Tax:'20', Total:'400', Received:'300', Outstanding:'100', Status:'Payment Pending', actions:'pay view' },
    //   { Invoice: 'INV-12345', InvoiceDate: '12/03/2022', Supplier: 'Aqua Born Ltd', Amount: '35', Tax:'20', Total:'400', Received:'300', Outstanding:'100', Status:'Payment Pending', actions:'pay view' },
    // ];
    return (
        <>
            <Box>
                <StyledCard sx={{ marginLeft: '-30px', marginRight: '-30px' }}>
                    <CardContent>
                        <Typography className={'cardHeader'} variant="h4" component="div">
                            <Box>Latest Order</Box>
                            {/* <Button variant='outlined'>View</Button> */}
                        </Typography>
                        <div style={{ height: 350, width: '100%' }}>
                            <CustomDataGrid
                                columns={columns}
                                rows={data}
                            // getRowId={(row) => row._id}
                            // loading={status === ApiStatus.LOADING}
                            />
                        </div>
                    </CardContent>
                </StyledCard>
            </Box>
        </>
    )
}

export default DelayTable;